import React, { useEffect, useState } from "react";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import "./ReportLoader.css";

const GENERATE_STEPS = [
  "Collecte des résultats",
  "Calcul des indicateurs",
  "Mise en page du document",
  "Création du PDF",
];
const STEP_MS = 2500;

const ReportLoader = ({ label = "Rapport", mode = "generate" }) => {
  const isGenerate = mode === "generate";
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!isGenerate) return; // no fake progress when just loading a file
    const id = setInterval(
      () => setActive((i) => Math.min(i + 1, GENERATE_STEPS.length - 1)),
      STEP_MS,
    );
    return () => clearInterval(id);
  }, [isGenerate]);

  return (
    <div className="report-loader" role="status" aria-live="polite">
      <div className="report-loader__visual" aria-hidden="true">
        <div className="report-loader__ring" />
        <div className="report-loader__doc">
          <span className="report-loader__line report-loader__line--title" />
          <div className="report-loader__kpis">
            <span /><span /><span />
          </div>
          <span className="report-loader__line" />
          <span className="report-loader__line" />
          <span className="report-loader__line report-loader__line--short" />
          <span className="report-loader__scan" />
        </div>
      </div>

      <div className="report-loader__text">
        <h3>{isGenerate ? "Génération du rapport" : "Chargement du rapport"}</h3>
        <p>
          {isGenerate
            ? `${label} en cours de préparation, cela peut prendre quelques secondes.`
            : `${label} en cours de chargement…`}
        </p>
      </div>

      <div className="report-loader__bar" aria-hidden="true">
        <span />
      </div>

      {isGenerate && (
        <ul className="report-loader__steps">
          {GENERATE_STEPS.map((step, i) => (
            <li
              key={step}
              className={
                i < active ? "is-done" : i === active ? "is-active" : undefined
              }
            >
              <span className="report-loader__dot">
                {i < active ? <CheckRoundedIcon sx={{ fontSize: 13 }} /> : null}
              </span>
              {step}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ReportLoader;